import { IStableTerminalNode, ITerminalNode, IUnstableTerminalNode } from "./TerminalScore";

export type UnstableNodeReportedError = 
'fail_max_disable_ratio' |
'fail_min_chan_count' |
'fail_min_median_capacity' |
'fail_uptime_ratio';

export class TerminalNodeInterpreter {
    constructor(public tNode: ITerminalNode) {}

    get isStable(): boolean {
        return !!(this.tNode as any).stable_inbound_peers
    }

    get goodPeers(): string[] {
        const set = new Set<string>();
        if (!this.isStable) {
            return [];
        }
        const n = this.tNode as IStableTerminalNode;
        const peers = new Set([...n.good_outbound_peers, ...n.good_inbound_peers])
        return Array.from(peers);
    }

    get stablePeers(): string[] {
        const set = new Set<string>();
        if (!this.isStable) {
            return [];
        }
        const n = this.tNode as IStableTerminalNode;
        const peers = new Set([...n.stable_outbound_peers, ...n.stable_inbound_peers])
        return Array.from(peers);
    }

    get unstableError(): UnstableNodeReportedError {
        const uNode = this.tNode as IUnstableTerminalNode;
        if (uNode.fail_max_disable_ratio) {
            return 'fail_max_disable_ratio';
        } else if (uNode.fail_min_chan_count) {
            return 'fail_min_chan_count';
        } else if (uNode.fail_min_median_capacity) {
            return 'fail_min_median_capacity';
        } else if (uNode.fail_uptime_ratio) {
            return 'fail_uptime_ratio';
        }
    }
}